import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { AppContext } from '../../../app-context';
import { ALL } from '../../../features/common/constants';
import { get } from '../../../features/common/http.services';
import { isNotNull } from '../../../features/common/util.services';
import './i-dropdown.style.scss';

export interface IDropdownItem {
    value: any,
    name: string
}

export interface IDropdownProps {
    label: string,
    name: string,
    value?: string,
    itemList?: any[], // IDropdownItem[],
    type?: string
    onChangeEvent?: any
    required?: boolean;
    rules?: any;
    url?: any;
    disabled?: boolean;
    allItemRequired?: boolean;
}

const IDropdown = (props: IDropdownProps) => {
    const appContext = useContext(AppContext);
    const [itemList, setItemList] = useState<any[]>(props.itemList ? props.itemList : []);
    const { control, register, setValue } = useFormContext();
    const [loader, setLoader] = useState(false);
    const onChangeEvent = (e: any) => {
        const value = e.target.value;
        setValue(props.name, value);
        if (props.onChangeEvent) {
            props.onChangeEvent(e);
        }
    }

    useEffect(() => {
        if (isNotNull(props.url)) {
            // setLoader(true);
            get(props.url, appContext,
                (response: any) => {
                    updateItemList(response.data);
                    setLoader(false);
                }, (error: any) => {
                    console.log(error);
                    setLoader(false);
                    appContext.setErrorMessage(error.message);
                });
        }
    }, [props.url]);

    useEffect(() => {
        const list = props.itemList ? props.itemList : [];
        updateItemList(list);
    }, [props.itemList]);

    const updateItemList = (list: any[]) => {
        if (props.allItemRequired) {
            setItemList([ALL, ...list]);
        } else if (!props.required) {
            setItemList(['', ...list]);
        } else {
            setItemList(list);
        }
    }

    return loader ? <></> : <Controller
        control={control}
        name={props.name}
        rules={{
            required: {
                value: props.required,
                message: "Required Field"
            },
            ...props.rules
        }}
        render={({ field, fieldState }) => (<FormControl className="i-dropdown"
                    required={props.required}>
            <InputLabel variant="outlined" shrink={true} id={props.name}>{props.label}</InputLabel>
            <Select
                {...field}
                {...register(props.name)}
                id={props.name}
                variant="outlined"
                size="small"
                onChange={onChangeEvent}
                labelId={props.name}
                disabled={props.disabled}
                label={props.label}
            >
                {itemList.map((item, idx) => (
                    <MenuItem value={item}>{item}</MenuItem>
                ))}
            </Select>
            <FormHelperText error={isNotNull(fieldState.error)}>{fieldState.error ? fieldState.error.message : null}</FormHelperText>
        </FormControl>
        )}
    />

};

export default IDropdown;